import Grid from '@mui/material/Grid'
import GroupsIcon from "@mui/icons-material/Groups";
import React from "react";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";
import {
  callAPI,
  getLocalValue,
  LoacalVariables,
  Method
} from "../../commonFunctions/CommonFunctions";
import { Header, IHeaderActions } from "../../Components/Header/Header";
import { resetDataComponent } from "../../StateManagement/actions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import { Helmet } from "react-helmet";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
import { openPopUp } from "../../Components/Dialog/OpenNewModal";
import { UpdateStatus } from "../components/UpdateStatus";
import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
import config from '../../Config/clientConfig.json';
import UserFormDrawer from './UserFormDrawer';

const UserList: React.FC<any> = React.memo(() => {
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  const navigate = useNavigate();
  const userType = getLocalValue(LoacalVariables.UserType);

  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [isPopupOpen, setPopupOpen] = React.useState(false); //for delete;
  const [selectedIdForDlt, setSelectedIdForDlt] = React.useState<any>(null);
  const [selectedIdForEdit, setSelectedIdForEdit] = React.useState<any>(null);
  const [userId, setUserId] = React.useState(null);

  const source = {
    url: "users/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: []
  };

  let limitedActions;
  // = userType === 'admin' || userType === 'district' ? ["Edit", "Delete", "Change Status", "View"] : ["View"]

  switch (userType) {
    case 'admin':
    case 'district':
      limitedActions = ["Edit", "Delete", "Change Status", "View"];
      break;
    case 'block':
      limitedActions = ["Edit", "Delete", "Change Status", "View"];
      break;
    case 'cds':
      limitedActions = ["View"];
      break;
    default:
      limitedActions = ["View"];
  }

  //edit / delete or perform other actions.
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      setSelectedIdForEdit(row?._id)
      handleClick();
    } else if (action === "Delete") {
      setPopupOpen(true);
      setSelectedIdForDlt(row?._id);
    } else if (action === "Change Status") {
      setUserId(row?._id);
    } else if (action === "View") {
      navigate(`/user/detail/${row?._id}`);
    }
  };


  const handleStatus = async (data: any) => {
    try {
      const response: any = await saveData(data);
      setUserId(null);

      if (response.success) {
        dispatch(resetDataComponent("usersGrid"));
        showMessage(
          response.message,
          "success"
        );
      }
    } catch (e: any) {
      showMessage(e.response?.data?.message || "An unexpected error occurred", "error");
    } finally {
      setUserId(null);

    }
  };

  const metadataStatus: IMetaData = {
    title: "Update Status",
    hideActions: false,
    content: (props: any, row: any) => <UpdateStatus {...props} config={config.userStatusConfig.staticOptionData} />,
    actions: [
      {
        label: "Cancel",
        className: "ws-cancel",
        type: "button"
      },
      {
        label: "Submit",
        onClick: handleStatus,
        type: "submit",
        autoFocus: true
      }
    ],
    isDragable: true
  };

  const saveData = async (data: any) => {
    const request: any = {
      status: data?.newStatus,
    };

    const response: any = await callAPI(
      `users/update/status/${userId}`,
      Method.PATCH,
      request
    );
    return response;
  };

  const handleCloseDialog = () => {
    setUserId(null);
  };

  React.useEffect(() => {
    if (userId) {
      openPopUp(metadataStatus, handleStatus, "40rem", handleCloseDialog);
    }
  }, [userId]);

  const handleDelete = () => {
    dispatch(resetDataComponent("usersGrid"));
    showMessage("User deleted successfully!", "success");
  };


  //drawer menus for open & close;
  const handleClick = () => {
    setDrawerOpen(true)
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false)
    setSelectedIdForEdit(null)
  }

  const columns: IColumns[] = [
    {
      header: "Name",
      fieldName: "name",
      tooltip: true,
      sortable: true
    },

    {
      header: "Phone",
      fieldName: "mobile",
      tooltip: true,
      sortable: true
    },
    {
      header: "Role",
      fieldName: "role",
      tooltip: true,
      sortable: true
    },
    {
      header: "Date",
      fieldName: "createdAt",
      tooltip: true,
      type: "date"
    },

    { header: "Status", fieldName: "isActive", type: "status" },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: limitedActions,
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  const action: IHeaderActions = {
    type: "button",
    text: "+ New User",
    size: "medium",
    onClick: handleClick,
    variant: "contained",
    color: "primary",
    sx: {
      textTransform: "none",
      color: "white",
      borderImage: "linear-gradient(95.53deg, #4DD26B 0%, #08B1B6 99.12%)",
      borderImageSlice: 1,
      backgroundImage: "linear-gradient(95.53deg, #4DD26B 0%, #08B1B6 99.12%)",
      "&:hover": {
        backgroundImage: "linear-gradient(95.53deg, #4DD26B 0%, #08B1B6 99.12%)",
        opacity: 0.9,
      },
    }
  };

  const filterFields = [
    { type: "text", fieldName: "name", label: "Name", operator: "regex" },
    { type: "text", fieldName: "mobile", label: "Mobile Number", operator: "regex" },
    { type: "text", fieldName: "email", label: "Email", operator: "regex" },
    {
      type: "dropdown", fieldName: "role", label: "Role", options: [
        { label: "Admin", value: "admin" },
        { label: "District", value: "district" },
        { label: "Block", value: "block" },
        { label: "CDS", value: "cds" }
      ],
    },
    {
      type: "dropdown",
      fieldName: "isActive",
      label: "Status",
      options: [
        { label: "Active", value: "true" },   // ← value as string;
        { label: "Inactive", value: "false" }
      ]
    },
    { type: "date", fieldName: "createdAt", label: "Created At" }
  ];


  return (
    <>
      <Helmet>
        <title>Users | Willsoar Technologies</title>
        <meta
          name="description"
          content="Manage all your users in one place. View, add, edit or delete user information easily."
        />
      </Helmet>
      <Grid p={2} mb={6}>
        {userType === "admin" || userType === "block" ? <Header
          type="new"
          title="Users"
          id={"userHeader"}
          action={action}
          icon={<GroupsIcon fontSize="medium" sx={{ color: "#7D79C2" }} />}
        /> : <Header
          type="new"
          title="Users"
          id={"userHeader"}
          icon={<GroupsIcon fontSize="medium" sx={{ color: "#7D79C2" }} />}
        />}

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <WSDataGrid
              id="usersGrid"
              columns={columns}
              source={source}
              searchBox={{ fieldName: "mobile" }}
              filterFields={filterFields}
              exportCsv
              buttonStyle='Sigma'
            />
          </Grid>
        </Grid>

        {isPopupOpen && (
          <ConfirmationPopup
            apiUrl={"users/delete/soft"}
            id={selectedIdForDlt}
            confirmMessage="Are you sure you want to delete this user?"
            subtitle="This action cannot be undone"
            open={isPopupOpen}
            onClose={() => setPopupOpen(false)}
            onConfirm={handleDelete}
          />
        )}
      </Grid>

      <UserFormDrawer
        open={drawerOpen}
        onClose={handleCloseDrawer}
        id={selectedIdForEdit}
      />
    </>
  );
});


export default UserList;